<template>
  <div>
    <!--私密货盘  -->
    <baseBreadcrumb :page="$t('message.customizedProducts')" :menu="$t('message.operationAndMaintenance')" />
    <div class="body">
      <div class="search">
        <div class="item" style="width: 220px;">
          <el-input v-model="datas.goods_id" placeholder="商品名称，支持模糊匹配" size="small"></el-input>
        </div>
        <!-- 选择分类 -->
        <div class="item">
          <el-cascader :options="classifyOption"
            :props="{ checkStrictly: true, children: 'childs', label: 'name', value: 'id' }" v-model="classifyIds"
            clearable placeholder="选择分类" size="small" @change="handleChange">
          </el-cascader>
        </div>
        <!-- 选择货盘 -->
        <div class="item">
          <el-select v-model="datas.pallet_config_id" placeholder="选择货盘" size="small">
            <el-option v-for="item in palletyOption" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 搜索 -->
        <el-button type="primary" @click="search" size="small">
          {{ $t('message.search') }}
        </el-button>
        <!-- 重置 -->
        <el-button @click="reset" size="small">
          {{ $t('message.reset') }}
        </el-button>
        <div class="btn">
          <!-- 一键导入商品 -->
          <el-button type="primary" class="primary" @click="oneClickImportProducts" size="small">
            {{ $t('message.oneClickImportProducts') }}
          </el-button>
          <!-- 商品分类管理 -->
          <el-button type="primary" class="primary" @click="$refs.classify.dialogVisible = true" size="small">
            {{ $t('message.productCategoryManagement') }}
          </el-button>
          <!-- 货盘管理 -->
          <el-button type="primary" class="primary" @click="$refs.pallet.dialogVisible = true" size="small">
            {{ $t('message.inventoryManagement') }}
          </el-button>
          <!-- 商品批量放入货盘 -->
          <el-button type="primary" class="primary" @click="batchAddProductsToInventory" size="small">
            {{ $t('message.batchAddProductsToInventory') }}
          </el-button>
          <!-- 批量删除 -->
          <el-button type="primary" class="dark" @click="batchDeletion" size="small">
            {{ $t('message.batchDeletion') }}
          </el-button>
          <!-- 创建商品 -->
          <el-button type="success" size="small">
            <router-link to="/createProduct" target="_blank" style="color: #fff;">
              {{ $t('message.CreateProduct') }}
            </router-link>
          </el-button>
        </div>
      </div>
      <div class="table">
        <ol>
          <li class="flex03">NO</li>
          <li class="flex03"> <el-checkbox v-model="checked" @change="allCheck"></el-checkbox></li>
          <!-- 商品链接 -->
          <li class="flex2">{{ $t('message.ProductLink') }}</li>
          <!-- 商品名称（中文）  -->
          <li>{{ $t('message.productNameChinese') }}</li>
          <!-- 商品名称（日语） -->
          <li>{{ $t('message.productNameJapanese') }}</li>
          <!-- 商品图片 -->
          <li>{{ $t('message.productPicture') }}</li>
          <!-- SUK -->
          <li class="flex2">SUK</li>
          <!-- 供应商名称 -->
          <li>{{ $t('message.supplierName') }}</li>
          <!-- 状态 -->
          <li>{{ $t('message.status') }}</li>
          <!-- 商品分类-->
          <li>{{ $t('message.productCategory') }}</li>
          <!-- 所属货盘 -->
          <li>{{ $t('message.associatedInventory') }}</li>
          <!-- 操作 -->
          <li>{{ $t('message.operation') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li class="flex03">{{ item.rowNumber }}</li>
          <li class="flex03"> <el-checkbox v-model="item.checked" @change="checkItem"></el-checkbox></li>
          <!-- 商品链接 -->
          <li class="flex2">
            <p>
              <a :href="`${item.goods_url}`" target="_blank" rel="noopener noreferrer" class="a-link">{{
                `${item.goods_url}` }}
              </a>
            </p>
          </li>
          <!-- 商品名称（中文）  -->
          <li>
            <p>{{ item.title }}</p>
          </li>
          <!-- 商品名称（日语） -->
          <li>
            <p>{{ item.title_jp }}</p>
          </li>
          <!-- 商品图片 -->
          <li>
            <el-image style="width: 60px; height: 60px" :src="item.pic" :preview-src-list="[item.pic]">
            </el-image>
          </li>
          <!-- SUK -->
          <li class="flex2">
            <div class="sku">
              <p v-for="(sku, skuIndex) in item.attribute" :key="skuIndex">
                {{ sku.key }} : <span v-for="(val, valIndex) in sku.value" :key="valIndex">{{ val.name }}, </span>
              </p>
            </div>
          </li>
          <!-- 供应商名称 -->
          <li>{{ item.supplier_name }}</li>
          <!-- 状态 -->
          <li>
            <el-switch v-model="item.status_convert" active-color="#13ce66" @change="statusSave(item)">
            </el-switch>
          </li>
          <!-- 商品分类 -->
          <li>
            <div>
              {{ item.raku_classify ? item.raku_classify.name : '' }}
            </div>
          </li>
          <!-- 所属货盘 -->
          <li>
            <div>
              <p v-for="(pallet, palletIndex) in item.raku_product_pallet" :key="palletIndex">
                {{ pallet.raku_pallet_config.name }}（ {{ pallet.raku_pallet_config.limiting_condition_name }}）
              </p>
            </div>
          </li>
          <!-- 操作 -->
          <li>
            <div>
              <router-link :to="'/createProduct?goods_id=' + item.goods_id" target="_blank" style="margin-right: 5px;">
                <el-button size="small" type="primary" class="primary">
                  {{ $t('message.redact')
                  }}</el-button>
              </router-link>
              <el-button size="small" type="primary" class="dark" @click="rakuProductDelete([item.goods_id])">{{
                $t('message.delete') }}</el-button>
            </div>
          </li>
        </ul>
      </div>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 商品分类 -->
    <classify ref="classify" :classifyOption="classifyOption" />
    <!-- 货盘 -->
    <pallet ref="pallet" />
    <!-- 商品放入货盘 -->
    <batchAddProductsToInventory ref="batchAddProductsToInventory" />
    <!--一键导入商品  -->
    <oneClickImportProducts ref="oneClickImportProducts" />
  </div>
</template>
<script>
import classify from './components/classify'
import pallet from './components/pallet'
import batchAddProductsToInventory from './components/batchAddProductsToInventory'
import oneClickImportProducts from './components/oneClickImportProducts'
export default {
  components: {
    batchAddProductsToInventory,
    classify,
    pallet,
    oneClickImportProducts,
  },
  data() {
    return {
      checked: false,
      datas: {
        keywords: '',
        classify_id: '',
        pallet_config_id: '',
        page: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: [],
      classifyOption: [],//分类列表
      classifyIds: [],
      palletyOption: [],//货盘配置列表
    };
  },
  created() {
    this.rakuProductList()
    this.classifyList()
    this.palletConfigList()
  },
  methods: {
    // 获取分类列表
    classifyList() {
      this.$api.siteConfiguration.classifyList().then(res => {
        this.classifyOption = res.data
      })
    },
    // 分类
    handleChange(e) {
      this.datas.classify_id = e[e.length - 1]
    },
    //货盘配置列表
    palletConfigList() {
      this.$api.siteConfiguration.palletConfigList().then(res => {
        res.data.forEach(item => {
          item.default_checked = item.default_uses ? true : false
        })
        this.palletyOption = res.data
      })
    },
    rakuProductList() {
      this.$api.siteConfiguration.rakuProductList(this.datas).then(res => {
        res.data.data.forEach(item => {
          item.checked = false
          item.status_convert = item.status == 1 ? true : false
        })
        this.tableData = res.data.data
        this.total = res.data.total
        this.checked = false
      })
    },
    // 搜索
    search() {
      this.datas.page = 1
      this.rakuProductList()
    },
    // 重置
    reset() {
      this.datas = {
        classify_id: '',
        keywords: '',
        pallet_config_id: '',
        page: 1,
        pageSize: 10
      }
      this.classifyIds = []
      this.rakuProductList()
    },
    // 分页
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.rakuProductList();
    },
    // 一页条数
    handleCurrentChange(val) {
      this.datas.page = val;
      this.rakuProductList();
    },
    // 单选
    checkItem() {
      this.checked = this.tableData.every(item => item.checked)
      this.$forceUpdate()
    },
    // 全选
    allCheck() {
      this.tableData.forEach(item => {
        item.checked = this.checked
      })
      this.$forceUpdate()
    },
    //修改商品状态
    statusSave(item) {
      let datas = {
        goods_id: item.goods_id,
        status: item.status_convert ? 1 : 0
      }
      this.$api.siteConfiguration.statusSave(datas)
    },
    // 删除
    rakuProductDelete(goods_id_set) {
      this.$confirm('删除后，商品相关信息将无法进行查看，商品链接也无法使用，是否确认删除商品？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.siteConfiguration.rakuProductDelete({ goods_id_set }).then(res => {
          this.$message.success(res.msg)
          this.rakuProductList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 批量删除
    batchDeletion() {
      let goods_id_set = []
      this.tableData.forEach(item => {
        if (item.checked) {
          goods_id_set.push(item.goods_id)
        }
      })
      if (goods_id_set == false) return this.$message.error('请选择商品')
      this.rakuProductDelete(goods_id_set)
    },
    //编辑商品
    redact(item) {
      this.$refs.createProduct.isAdd = false
      this.$refs.createProduct.ruleForm = JSON.parse(JSON.stringify(item))
      this.$refs.createProduct.dialogVisible = true
    },
    // 新增商品
    createProduct() {
      this.$refs.createProduct.isAdd = true
      this.$refs.createProduct.ruleForm = {
        title: '',
        title_jp: '',
        link: '',
        pic: '',
        images: [],
        status_convert: true,
        desc: '',
        sku: [],
      }
      this.$refs.createProduct.dialogVisible = true
    },
    // 商品批量放入货盘
    batchAddProductsToInventory() {
      let goodsIds = []
      this.tableData.forEach(item => {
        if (item.checked) {
          goodsIds.push(item.goods_id)
        }
      })
      if (goodsIds == false) return this.$message.error('请选择要操作的商品')
      this.$refs.batchAddProductsToInventory.dialogVisible = true
      this.$refs.batchAddProductsToInventory.goodsIds = goodsIds
    },
    // 一键导入商品
    oneClickImportProducts() {
      this.$refs.oneClickImportProducts.dialogVisible = true
      this.$refs.oneClickImportProducts.success = false
    },
  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;
  position: relative;

  .item {
    width: 180px;
    margin-right: 24px;
  }

  .btn {
    position: absolute;
    top: 0;
    right: 0px;
  }
}

.table {
  margin: 24px 0;

  .flex03 {
    flex: 0.3
  }

  .flex2 {
    flex: 2;

    .sku {
      width: 100%;
      text-align: left;
    }
  }
}
</style>